{
  /* <Pane marginBottom={4}>
    <Pane.Header>
        <Pane.Title>The title of the pane</Pane.Title>
        <button>Edit</button>
    </Pane.Header>
    <Pane.Body css={{ backgroundColor: "red" }} className="foo">
        <p>Content and stuff</p>
    </Pane.Body>
</Pane> */
}

import PropTypes from "prop-types"
import { StackView } from "@planningcenter/tapestry-react"

const Pane = ({ className, children, ...props }) => {
  return (
    <StackView className={`pane ${className ? className : ""}`} {...props}>
      {children}
    </StackView>
  )
}

Pane.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
}

export default Pane
